import { render, staticRenderFns } from "./CompletePrivateReservation.vue?vue&type=template&id=6c1b89fb&scoped=true&"
import script from "./CompletePrivateReservation.vue?vue&type=script&lang=js&"
export * from "./CompletePrivateReservation.vue?vue&type=script&lang=js&"
import style0 from "./CompletePrivateReservation.vue?vue&type=style&index=0&id=6c1b89fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b89fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
